/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
import { BASE_LAYOUT_VARIANTS, SHARED_LAYOUT_TRANSITION } from '../styles/animations';

interface WithLayoutAnimationProps {
  motionProps?: HTMLMotionProps<'div'>;
}

export function withLayoutAnimation<T extends object>(Component: React.ComponentType<T>) {
  const WrappedComponent = React.forwardRef<HTMLDivElement, T & WithLayoutAnimationProps>(
    ({ motionProps, ...restProps }, ref) => {
      return (
        <motion.div
          ref={ref}
          layout="position"
          variants={BASE_LAYOUT_VARIANTS}
          initial="initial"
          animate="animate"
          exit="exit"
          transition={SHARED_LAYOUT_TRANSITION}
          data-testid="with-layout-animation"
          style={{
            overflow: 'hidden',
            originY: 0,
            width: '100%',
          }}
          {...motionProps}
          {...((restProps as any)['data-dropzone'] ? { 'data-dropzone': (restProps as any)['data-dropzone'] } : {})}
        >
          <Component {...(restProps as T)} />
        </motion.div>
      );
    },
  );

  WrappedComponent.displayName = `withLayoutAnimation(${Component.displayName || Component.name || 'Component'})`;
  return WrappedComponent;
}

export const AnimatedWrapper = withLayoutAnimation<{ children: React.ReactNode }>(({ children }) => <>{children}</>);

AnimatedWrapper.displayName = 'AnimatedWrapper';
